module.exports = __webpack_public_path__ + "static/media/membership-banner.46f058a9.svg";